/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
import Banner from '../components/Banner';
import CaptureError from '../components/CaptureError';
import ContentAnchor from '../components/ContentAnchor';
import ContentFavorite from '../components/ContentFavorite';
import ContentLightbox from '../components/ContentLightbox';
import ContentLink from '../components/ContentLink';
import ContentNeoOverlay from '../components/ContentNeoOverlay';
import ContentPillLinks from '../components/ContentPillLinks';
import ContentVideoWistia from '../components/ContentVideoWistia';
import DataProviderGlobal from '../components/DataProviderGlobal';
import EditorialArticleTeaser from '../components/EditorialArticleTeaser';
import EditorialButton from '../components/EditorialButton';
import EditorialCatalogHeader from '../components/EditorialCatalogHeader';
import EditorialCollapsable from '../components/EditorialCollapsable';
import EditorialColumns2 from '../components/EditorialColumns2';
import EditorialDealerFinder from '../components/EditorialDealerFinder';
import EditorialDetailPlanningAlternatives from '../components/EditorialDetailPlanningAlternatives';
import EditorialDetailShowroom from '../components/EditorialDetailShowroom';
import EditorialDetailSimple from '../components/EditorialDetailSimple';
import EditorialDownload from '../components/EditorialDownload';
import EditorialFeed from '../components/EditorialFeed';
import EditorialGallery from '../components/EditorialGallery';
import EditorialGroup from '../components/EditorialGroup';
import EditorialHeadline from '../components/EditorialHeadline';
import EditorialHighlight from '../components/EditorialHighlight';
import EditorialHighlightGroup from '../components/EditorialHighlightGroup';
import EditorialImage from '../components/EditorialImage';
import EditorialInstagram from '../components/EditorialInstagram';
import EditorialInternationalProjectHeader from '../components/EditorialInternationalProjectHeader';
import EditorialInternationalProjectsAreaProjects from '../components/EditorialInternationalProjectsAreaProjects';
import EditorialInternationalProjectsHeader from '../components/EditorialInternationalProjectsHeader';
import EditorialInternationalProjectsShowroomsWorldwide from '../components/EditorialInternationalProjectsShowroomsWorldwide';
import EditorialInternationalProjectsSiblingProjects from '../components/EditorialInternationalProjectsSiblingProjects';
import EditorialInternationalProjectsTemplate from '../components/EditorialInternationalProjectsTemplate';
import EditorialInternationalProjectsWorldwideProjects from '../components/EditorialInternationalProjectsWorldwideProjects';
import EditorialKitchenTalkAllFeed from '../components/EditorialKitchenTalkAllFeed';
import EditorialKitchenTalkArticleHeader from '../components/EditorialKitchenTalkArticleHeader';
import EditorialKitchenTalkCategoryFeed from '../components/EditorialKitchenTalkCategoryFeed';
import EditorialKitchenTalkFeed from '../components/EditorialKitchenTalkFeed';
import EditorialKitchenTalkFeedHeader from '../components/EditorialKitchenTalkFeedHeader';
import EditorialMedia from '../components/EditorialMedia';
import EditorialMediaDetail from '../components/EditorialMediaDetail';
import EditorialMediaDetailGroup from '../components/EditorialMediaDetailGroup';
import EditorialMediaGroup from '../components/EditorialMediaGroup';
import EditorialMNKAccount from '../components/EditorialMNKAccount';
import EditorialMNKChecklistForm from '../components/EditorialMNKChecklistForm';
import EditorialMNKKitchenPlanDownload from '../components/EditorialMNKKitchenPlanDownload';
import EditorialMNKKitchenPlans from '../components/EditorialMNKKitchenPlans';
import EditorialMNKKitchenPlansGallery from '../components/EditorialMNKKitchenPlansGallery';
import EditorialMNKMoodboard from '../components/EditorialMNKMoodboard';
import EditorialMNKRetailerRequestForm from '../components/EditorialMNKRetailerRequestForm';
import EditorialMNKRetailerSelection from '../components/EditorialMNKRetailerSelection';
import EditorialMNKSelectData from '../components/EditorialMNKSelectData';
import EditorialMNKStage from '../components/EditorialMNKStage';
import EditorialMNKTeaser from '../components/EditorialMNKTeaser';
import EditorialMNKTeaserGroup from '../components/EditorialMNKTeaserGroup';
import EditorialMNKUserRegistrationConfirmation from '../components/EditorialMNKUserRegistrationConfirmation';
import EditorialMoodDetail from '../components/EditorialMoodDetail';
import EditorialNeoColGroup from '../components/EditorialNeoColGroup';
import EditorialNeoColMedia from '../components/EditorialNeoColMedia';
import EditorialNeoComparison from '../components/EditorialNeoComparison';
import EditorialNeoFullscreen from '../components/EditorialNeoFullscreen';
import EditorialNeoGroup from '../components/EditorialNeoGroup';
import EditorialNeoMedia from '../components/EditorialNeoMedia';
import EditorialNeoQuote from '../components/EditorialNeoQuote';
import EditorialNeoStage from '../components/EditorialNeoStage';
import EditorialNewsDetail from '../components/EditorialNewsDetail';
import EditorialNewsFeed from '../components/EditorialNewsFeed';
import EditorialPlanningAlternative from '../components/EditorialPlanningAlternative';
import EditorialPlanningAlternativeGroup from '../components/EditorialPlanningAlternativeGroup';
import EditorialProductDetail from '../components/EditorialProductDetail';
import EditorialRichText from '../components/EditorialRichText';
import EditorialSimpleHeader from '../components/EditorialSimpleHeader';
import EditorialTeaser from '../components/EditorialTeaser';
import EditorialTextMultiLine from '../components/EditorialTextMultiLine';
import EditorialTip from '../components/EditorialTip';
import EditorialVideo from '../components/EditorialVideo';
import EditorialVideoWistia from '../components/EditorialVideoWistia';
import GlobalAnchorNavigation from '../components/GlobalAnchorNavigation';
import GlobalFooter from '../components/GlobalFooter';
import GlobalForm from '../components/GlobalForm';
import GlobalHeader from '../components/GlobalHeader';
import GlobalHeaderLogo from '../components/GlobalHeaderLogo';
import GlobalHeaderMenuButton from '../components/GlobalHeaderMenuButton';
import GlobalHeaderMNKMenu from '../components/GlobalHeaderMNKMenu';
import GlobalHeaderMNKMenuLoggedIn from '../components/GlobalHeaderMNKMenuLoggedIn';
import GlobalHeaderMNKMenuLoggedOut from '../components/GlobalHeaderMNKMenuLoggedOut';
import GlobalHeaderSearch from '../components/GlobalHeaderSearch';
import GlobalHeaderSubmenu from '../components/GlobalHeaderSubmenu';
import GlobalMNKProgressbar from '../components/GlobalMNKProgressbar';
import LanguageSwitcher from '../components/LanguageSwitcher';
import EditorialMap from '../components/map/EditorialMap';
import GoogleMap from '../components/map/GoogleMap';
import MapSearchLocation from '../components/map/MapSearchLocation';
import ResultListRetailers from '../components/map/ResultListRetailers';
import ResultListShowrooms from '../components/map/ResultListShowrooms';
import EditorialNeoLightColGroup from '../components/Neo Light/EditorialNeoLightColGroup';
import EditorialNeoLightColMedia from '../components/Neo Light/EditorialNeoLightColMedia';
import EditorialNeoLightFullscreen from '../components/Neo Light/EditorialNeoLightFullscreen';
import EditorialNeoLightQuote from '../components/Neo Light/EditorialNeoLightQuote';
import EditorialNeoLightStage from '../components/Neo Light/EditorialNeoLightStage';
import NolteTags from '../components/NolteTags';
import Placeholder from '../components/Placeholder';
import EditorialSearchResults from '../components/Search/EditorialSearchResults';
import SearchResultList from '../components/Search/SearchResultList';
import SearchResultsHeader from '../components/Search/SearchResultsHeader';
import VisitorIdentification from '../components/VisitorIdentification';
const components = new Map();
components.set('Banner', Banner);
components.set('CaptureError', CaptureError);
components.set('ContentAnchor', ContentAnchor);
components.set('ContentFavorite', ContentFavorite);
components.set('ContentLightbox', ContentLightbox);
components.set('ContentLink', ContentLink);
components.set('ContentNeoOverlay', ContentNeoOverlay);
components.set('ContentPillLinks', ContentPillLinks);
components.set('ContentVideoWistia', ContentVideoWistia);
components.set('DataProviderGlobal', DataProviderGlobal);
components.set('EditorialArticleTeaser', EditorialArticleTeaser);
components.set('EditorialButton', EditorialButton);
components.set('EditorialCatalogHeader', EditorialCatalogHeader);
components.set('EditorialCollapsable', EditorialCollapsable);
components.set('EditorialColumns2', EditorialColumns2);
components.set('EditorialDealerFinder', EditorialDealerFinder);
components.set('EditorialDetailPlanningAlternatives', EditorialDetailPlanningAlternatives);
components.set('EditorialDetailShowroom', EditorialDetailShowroom);
components.set('EditorialDetailSimple', EditorialDetailSimple);
components.set('EditorialDownload', EditorialDownload);
components.set('EditorialFeed', EditorialFeed);
components.set('EditorialGallery', EditorialGallery);
components.set('EditorialGroup', EditorialGroup);
components.set('EditorialHeadline', EditorialHeadline);
components.set('EditorialHighlight', EditorialHighlight);
components.set('EditorialHighlightGroup', EditorialHighlightGroup);
components.set('EditorialImage', EditorialImage);
components.set('EditorialInstagram', EditorialInstagram);
components.set('EditorialInternationalProjectHeader', EditorialInternationalProjectHeader);
components.set('EditorialInternationalProjectsAreaProjects', EditorialInternationalProjectsAreaProjects);
components.set('EditorialInternationalProjectsHeader', EditorialInternationalProjectsHeader);
components.set('EditorialInternationalProjectsShowroomsWorldwide', EditorialInternationalProjectsShowroomsWorldwide);
components.set('EditorialInternationalProjectsSiblingProjects', EditorialInternationalProjectsSiblingProjects);
components.set('EditorialInternationalProjectsTemplate', EditorialInternationalProjectsTemplate);
components.set('EditorialInternationalProjectsWorldwideProjects', EditorialInternationalProjectsWorldwideProjects);
components.set('EditorialKitchenTalkAllFeed', EditorialKitchenTalkAllFeed);
components.set('EditorialKitchenTalkArticleHeader', EditorialKitchenTalkArticleHeader);
components.set('EditorialKitchenTalkCategoryFeed', EditorialKitchenTalkCategoryFeed);
components.set('EditorialKitchenTalkFeed', EditorialKitchenTalkFeed);
components.set('EditorialKitchenTalkFeedHeader', EditorialKitchenTalkFeedHeader);
components.set('EditorialMedia', EditorialMedia);
components.set('EditorialMediaDetail', EditorialMediaDetail);
components.set('EditorialMediaDetailGroup', EditorialMediaDetailGroup);
components.set('EditorialMediaGroup', EditorialMediaGroup);
components.set('EditorialMNKAccount', EditorialMNKAccount);
components.set('EditorialMNKChecklistForm', EditorialMNKChecklistForm);
components.set('EditorialMNKKitchenPlanDownload', EditorialMNKKitchenPlanDownload);
components.set('EditorialMNKKitchenPlans', EditorialMNKKitchenPlans);
components.set('EditorialMNKKitchenPlansGallery', EditorialMNKKitchenPlansGallery);
components.set('EditorialMNKMoodboard', EditorialMNKMoodboard);
components.set('EditorialMNKRetailerRequestForm', EditorialMNKRetailerRequestForm);
components.set('EditorialMNKRetailerSelection', EditorialMNKRetailerSelection);
components.set('EditorialMNKSelectData', EditorialMNKSelectData);
components.set('EditorialMNKStage', EditorialMNKStage);
components.set('EditorialMNKTeaser', EditorialMNKTeaser);
components.set('EditorialMNKTeaserGroup', EditorialMNKTeaserGroup);
components.set('EditorialMNKUserRegistrationConfirmation', EditorialMNKUserRegistrationConfirmation);
components.set('EditorialMoodDetail', EditorialMoodDetail);
components.set('EditorialNeoColGroup', EditorialNeoColGroup);
components.set('EditorialNeoColMedia', EditorialNeoColMedia);
components.set('EditorialNeoComparison', EditorialNeoComparison);
components.set('EditorialNeoFullscreen', EditorialNeoFullscreen);
components.set('EditorialNeoGroup', EditorialNeoGroup);
components.set('EditorialNeoMedia', EditorialNeoMedia);
components.set('EditorialNeoQuote', EditorialNeoQuote);
components.set('EditorialNeoStage', EditorialNeoStage);
components.set('EditorialNewsDetail', EditorialNewsDetail);
components.set('EditorialNewsFeed', EditorialNewsFeed);
components.set('EditorialPlanningAlternative', EditorialPlanningAlternative);
components.set('EditorialPlanningAlternativeGroup', EditorialPlanningAlternativeGroup);
components.set('EditorialProductDetail', EditorialProductDetail);
components.set('EditorialRichText', EditorialRichText);
components.set('EditorialSimpleHeader', EditorialSimpleHeader);
components.set('EditorialTeaser', EditorialTeaser);
components.set('EditorialTextMultiLine', EditorialTextMultiLine);
components.set('EditorialTip', EditorialTip);
components.set('EditorialVideo', EditorialVideo);
components.set('EditorialVideoWistia', EditorialVideoWistia);
components.set('GlobalAnchorNavigation', GlobalAnchorNavigation);
components.set('GlobalFooter', GlobalFooter);
components.set('GlobalForm', GlobalForm);
components.set('GlobalHeader', GlobalHeader);
components.set('GlobalHeaderLogo', GlobalHeaderLogo);
components.set('GlobalHeaderMenuButton', GlobalHeaderMenuButton);
components.set('GlobalHeaderMNKMenu', GlobalHeaderMNKMenu);
components.set('GlobalHeaderMNKMenuLoggedIn', GlobalHeaderMNKMenuLoggedIn);
components.set('GlobalHeaderMNKMenuLoggedOut', GlobalHeaderMNKMenuLoggedOut);
components.set('GlobalHeaderSearch', GlobalHeaderSearch);
components.set('GlobalHeaderSubmenu', GlobalHeaderSubmenu);
components.set('GlobalMNKProgressbar', GlobalMNKProgressbar);
components.set('LanguageSwitcher', LanguageSwitcher);
components.set('EditorialMap', EditorialMap);
components.set('GoogleMap', GoogleMap);
components.set('MapSearchLocation', MapSearchLocation);
components.set('ResultListRetailers', ResultListRetailers);
components.set('ResultListShowrooms', ResultListShowrooms);
components.set('EditorialNeoLightColGroup', EditorialNeoLightColGroup);
components.set('EditorialNeoLightColMedia', EditorialNeoLightColMedia);
components.set('EditorialNeoLightFullscreen', EditorialNeoLightFullscreen);
components.set('EditorialNeoLightQuote', EditorialNeoLightQuote);
components.set('EditorialNeoLightStage', EditorialNeoLightStage);
components.set('NolteTags', NolteTags);
components.set('Placeholder', Placeholder);
components.set('EditorialSearchResults', EditorialSearchResults);
components.set('SearchResultList', SearchResultList);
components.set('SearchResultsHeader', SearchResultsHeader);
components.set('VisitorIdentification', VisitorIdentification);
export default function componentFactory(componentName) {
  return components.get(componentName);
};
